<div class="layout">
  <app-loading></app-loading>
  <app-warning></app-warning>
  <app-warning-confirm></app-warning-confirm>
  <app-merchant-navigation></app-merchant-navigation>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
